export default __webpack_public_path__ + "static/media/review3.272fbf1b.jpg";